/* eslint-disable no-unused-vars */
const devApiDomain = 'https://lhd-api-dev.dankal.cn/v1/cms/' // 开发环境api域名
const stageApiDomain = '' // 测试环境api域名
const proApiDomain = 'https://website-api.idalhome.com/v1/cms/' // 生产环境api域名
const uploadDomain = 'https://upload-z0.qiniup.com/' // 七牛云华北区上传域名,华东去掉"-z2",华北改成"z1"
const devImgDomain = '' // 开发环境图片域名
const proImgDomain = '' // 生产环境图片域名

export default {
  apiDomain: proApiDomain,
  imgDomain: devImgDomain,
  uploadDomain,
}



// WEBPACK FOOTER //
// ./src/configs/env.js